module.exports = __webpack_public_path__ + "img/unlock.a29bd377.svg";